import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Button, CloseButton, Container, Form, Image, ProgressBar } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import * as RIcon from "react-icons/fa"
import { LinkContainer } from 'react-router-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Iobserver, LoginInfo } from '../App';
import { isLoggin } from '../service/LoginService';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import { Select } from '@mui/material';

const StampManage = () => {
    async function getStamp(userId,page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/stamp/user/"+userId+"/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function deleteStamp(stampId){
        return await new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/stamp/user/"+stampId).then((r)=>r.json().then((d)=>{
            return d
        }))
    }
    async function publicStamp(stampId,status){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/stamp/public/",{stampId:stampId,status:status}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    // 翻訳
    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    // ナビゲート
    const navigate = useNavigate();
    // 画像遅延ロード
    const observer = useContext(Iobserver)

    // URLパラメータ
    let param = useParams();

    const [imageList,setImageList] = useState([...Array(0)])
    const [message,setMessage] = useState('')
    const [item, selectItem] = useState('');
    const [deleted, setDeleted] = useState('');

    // 検索情報
    const [page,setPage] = useState(0)

    // アップロード処理
    const [uploading,setUploading] = useState(false)
    const [progressNow,setProgressNow] = useState(0)
    const [progressLabel,setProgressLabel] = useState(0)
    const maxFileSize = 104857600 // 100MB

    // 投稿完了後
    const [postedStampId,setPostedStampId] = useState("")

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    const [okButtonShow,setOkButtonShow] = useState(false)
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    useEffect(() => {
        if(loginInfo.result === false){
            navigate("/")
        }
    },[loginInfo])

    // 初期処理とページ遷移
    useEffect(() =>{
        // タイトル設定
        document.querySelector("title").textContent = "スタンプ管理 - アワートAI"

        let currentPage = 1
        if(param.page === undefined){
            currentPage = 1
        } else {
            currentPage = parseInt(param.page)
        }
        setPage(currentPage)
        // 初期処理では取得せず、ページ番号が確定してから取得する
        if(page > 0){
            if(loginInfo.result){ // ログイン確認が終わるまで待機する必要あり。
                getStamp(loginInfo.userId,currentPage).then(json => {
                    if(json.result){
                        if(json.data.length > 0){
                            setMessage("")
                        } else {
                            setMessage("まだスタンプがありません。スタンプを登録してみませんか？コメント投稿時に利用できます。")
                        }
                        // スクロールを最上位に戻す
                        window.scrollTo({top:0,left:0,behavior:"instant"})
                        setImageList(json.data)
                    }
                })
            }
        }
    },[loginInfo,deleted,page])

    // 画像遅延ロード
    useEffect(() => {
        //document.querySelectorAll(".lazy").forEach(e => observer.observe(e))
    },[imageList])

    // 削除ボタン
    let okButton
    if(!okButtonShow){
        okButton = ""
    } else {
        okButton = <Button onClick={() => {
            setShow(false)
            deleteStamp(item).then(r=>{
                if(r.result){
                    setDeleted(item)
                } else {
                    dialog("エラー",r.errors)
                }
                setOkButtonShow(false)
            })
        }}>OK</Button>
    }

    function upload(files){
        let fd = new FormData()

        for(let i = 0;i < files.length;i++){
            fd.append("file[]",files[i])
        }
        let req = new XMLHttpRequest()
        req.open("POST",ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/upload/stamp")
        req.withCredentials = true
        req.onreadystatechange = () => {
            if(req.readyState === 4 && req.status === 200){
                if(req.responseText !== ""){
                    var r = JSON.parse(req.responseText)
                    if(r.result){
                        // スタンプID
                        setPostedStampId(r.stampId)
                        // アップロード終了
                        setUploading(false)
                        // ページ更新
                        setPage(0)
                    } else {
                        setUploading(false)
                        dialog("エラー",r.errors.join("\r\n"))
                    }
                    document.getElementById("file").value = ""
                    setProgressNow(0)
                    setProgressLabel(0)
                }
            }
        }
        req.onerror = () => {
            setProgressNow(0)
            setProgressLabel(0)
            setUploading(false)
            dialog("エラー","通信エラーが発生しました。")
            document.getElementById("file").value = ""
        }
        req.upload.onprogress = (e) => {
            let per = Math.floor(e.loaded / e.total * 100)
            let label = ""
            if(per === 100){
                label = "登録中"
            } else {
                label = per + "%"
            }
            setProgressNow(per)
            setProgressLabel(label)
        }
        req.send(fd)
    }

    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} button={okButton} />
        <Header />
        <Container className='mt-3 mb-3' style={{fontSize:"24px",fontWeight:"bold",borderLeft:"10px solid lightblue"}}><RIcon.FaStamp style={{color:"orange"}} /> {t("stamp.title")}</Container>
        <Container style={{border:"3px solid #555555",borderRadius:"5px"}}
            onClick={() => {
                document.getElementById("file").click()
            }}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => {
                e.preventDefault()
                if(e.dataTransfer.files.length > 0){
                    setUploading(true)
                    upload(e.dataTransfer.files)
                }
            }}
        >
            {t("stamp.resolution")}：512x512<br />
            <Icon.Plus style={{borderRadius:"5px",border:"3px solid #AAAAAA",fontSize:"64px",cursor:"pointer"}} className="m-3" />
        </Container>
        <Container className='mt-3'>
            {uploading && (<><ProgressBar id="progress" animated now={progressNow} label={`${progressLabel}`} style={{marginBottom:"10px"}} /></>)}
        </Container>
        <Form.Control type="file" encType="multipart/form-data" accept=".jfif,.jpg,.jpeg,.png,.gif,.webp" className='d-none' id="file" multiple onChange={(e) => {
            setUploading(true)
            upload(e.currentTarget.files)
        }} />
        <Container className='d-flex flex-row justify-content-start flex-wrap w-100'>
            {message}
            {imageList.map((data,i) => {
                if(i === 30){
                    return ""
                }
            return <Container style={{position:"relative",width:"180px"}} className="mb-3 p-0" key={i}>
                        <Container style={{position:"relative",width:"180px",height:"180px",padding:0}}>
                            <Badge bg="danger" style={{position:"absolute",zIndex:"1",top:"20px",left:"20px",display:data.age_limit === 2 ? "block":"none"}}>
                                R-18
                            </Badge>
                            <Badge bg="danger" style={{position:"absolute",zIndex:"1",top:"20px",left:"20px",display:data.age_limit === 3 ? "block":"none"}}>
                                R-18G
                            </Badge>
                            <Badge bg="secondary" style={{position:"absolute",zIndex:"1",bottom:"20px",left:"20px",display:data.img_count > 1 ? "block":"none"}}>
                                <Icon.CollectionFill /> {data.img_count}
                            </Badge>
                            <Badge bg="secondary" style={{position:"absolute",zIndex:"1",top:"20px",right:"50px",cursor:"pointer",display:"none"}}
                                onClick={() => {
                                    if(data.public === 0){
                                        dialog("",<>
                                            全体に公開しますか？自分以外の利用者がスタンプを利用できるようになります。<br />
                                            一番近いタグを選んでください。<br />
                                            <Form.Select>
                                                <option value="いいね">いいね</option>
                                                <option value="ありがとう">ありがとう</option>
                                                <option value="すごい">すごい</option>
                                                <option value="うれしい">うれしい</option>
                                                <option value="かっこいい">かっこいい</option>
                                                <option value="かわいい">かわいい</option>
                                                <option value="きれい">きれい</option>
                                                <option value="おどろき">おどろき</option>
                                                <option value="サムズアップ">サムズアップ</option>
                                                <option value="こまる">こまる</option>
                                                <option value="考え中">考え中</option>
                                                <option value="なみだ">なみだ</option>
                                                <option value="どうして？">どうして？</option>
                                                <option value="ハート">ハート</option>
                                                <option value="割れたハート">割れたハート</option>
                                                <option value="興奮">興奮</option>
                                                <option value="そんな">そんな</option>
                                                <option value="禁止">禁止</option>
                                            </Form.Select>
                                            <Button onClick={() => publicStamp(data.stamp_id,1)} className='mt-3'>公開する</Button>
                                        </>)
                                    } else {
                                        dialog("",<>公開を停止しますか？自分だけが利用できるようになります。<br /><Button onClick={() => publicStamp(data.stamp_id,0)}  className='mt-3'>公開停止する</Button></>)
                                    }
                                }}
                            >
                                {data.public === 0 ? <RIcon.FaLock  /> : <RIcon.FaLockOpen />}
                            </Badge>
                            <CloseButton style={{position:"absolute",zIndex:"1",top:"20px",right:"20px",backgroundColor:"#FFFFFF"}} onClick={()=>{
                                selectItem(data.stamp_id)
                                setOkButtonShow(true)
                                dialog("確認",
                                    <Container style={{margin:"0 auto"}}>
                                        <Container className='text-center'>{t("common.delete")}</Container>
                                        <Container style={{position:"relative",width:"180px",height:"180px",padding:0}}>
                                            <Image src={ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/stamp/'+(data.stamp_id)+"_m"+ApiFetch.API_THUMB_EXT} style={{objectFit:"cover",position:"absolute",width:"100%",height:"100%"}} className="p-2" />
                                        </Container>
                                        <Container style={{fontWeight:"bold",fontSize:"15px"}} className='text-center'>{data.title}</Container>
                                    </Container>
                                    )
                            }} />
                            {
                            // <Badge bg="white" style={{cursor:"pointer",position:"absolute",backgroundColor:"#FFFFFF",padding:"5px",zIndex:1,top:"20px",right:"50px"}} onClick={() => navigate("/edit/"+data.group_id)}>
                            //     <Icon.PencilSquare style={{color:"#000000"}} /> <span style={{color:"#555555"}}>編集</span>
                            // </Badge>
                            // <FavoriteIcon type="image" id={data.group_id} style={{cursor:"pointer",position:"absolute",zIndex:"1",bottom:"20px",right:"20px"}} favorite={data.favorite} dialog={dialog} />
                            }
                            <Image loading="lazy" src={ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/stamp/'+(data.stamp_id)+"_m"+ApiFetch.API_THUMB_EXT} style={{objectFit:"cover",position:"absolute",width:"100%",height:"100%"}} className="p-2"
                            onMouseOver={(e) => {
                                e.currentTarget.src = ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/stamp/'+(data.stamp_id)+ApiFetch.API_THUMB_EXT
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.src = ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/stamp/'+(data.stamp_id)+"_m"+ApiFetch.API_THUMB_EXT
                            }}
                            />
                        </Container>
                        <Container style={{fontWeight:"bold",fontSize:"15px"}}><Link to={"/image/"+(data.stamp_id)} style={{color:"#555555",textDecoration:"none"}}>{data.title}</Link></Container>
                        <Container>
                            {data.original === 1 ? (<Badge bg="secondary" className='m-1'><Icon.Brush /> オリジナル</Badge>) : ""}
                        </Container>
                    </Container>
            })}
        </Container>
        <Container className='d-flex justify-content-between' style={{width:"200px"}}>
            {page > 1 ? (
                    <Button onClick={() => {
                        let p = page - 1
                        setPage(p)
                        navigate("/stampManage/" + p)
                    } }>{t("common.prev")}</Button>
                ) : <Button disabled>{t("common.prev")}</Button>}
            {imageList.length > 30 ? (
                    <Button onClick={() => {
                        let p = page + 1
                        setPage(p)
                        navigate("/stampManage/" + p)
                    } }>{t("common.next")}</Button>
                ) : <Button disabled>{t("common.next")}</Button>}
        </Container>
        <Footer />
    </div>
    )
}

export default StampManage;
